import { BasicCalls } from '@/api/models'

/**
 * Server-side expense code search (core-api), used at checkout for companies with
 * company-level expense codes. Resolves the lists keyed by the checkout field id:
 * the allowance's / canteen's own field is 'default', the additional fields their id.
 */
class ExpenseCodeSearch extends BasicCalls {
    constructor() {
        super()
        this.apiRoot = 'frontend-api'
        this.apiVersion = null
        this.apiBase = 'expense-code'
    }

    async search(type, id, search) {
        const rows = await this.fetch(`${type}/${id}`, search ? { search } : {})
        if (!Array.isArray(rows)) throw new Error('Unexpected expense code search response')
        return rows.reduce((lists, row) => {
            const codes = row?.available_expense_codes
            lists[row?.id === -1 ? 'default' : String(row?.id)] = {
                items: Array.isArray(codes?.items) ? codes.items : [],
                hasMore: Boolean(codes?.has_more),
                total: Number(codes?.total) || 0,
            }
            return lists
        }, {})
    }
}

export { ExpenseCodeSearch }
